<nav class="movie-site_landing-menu_nav">
  <ul>
    @for (navAction of configuredNavActions(); track navAction) {
      <li>
        <movie-site-nav-action [navAction]="navAction" />
      </li>
    }
  </ul>
</nav>
